export interface MangaChapter {
  id: string;
  number: number;
  title: string;
  updatedAt: string;
}

export interface Manga {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  description: string;
  rating: number;
  status: string;
  updatedAt: string;
  chapters: MangaChapter[];
  views: number;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
}

export const categories: Category[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { slug: 'mystery', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'school', name: '校园', icon: 'ri-book-open-line' },
  { slug: 'historical', name: '古风', icon: 'ri-ancient-gate-line' },
];

export const mangaList: Manga[] = [
  {
    id: '1',
    slug: 'queen-of-tears',
    title: '泪之女王',
    author: '朴智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20manga%20cover%20art%20style%2C%20romance%20drama%2C%20elegant%20woman%20with%20tears%20in%20soft%20warm%20lighting%2C%20emotional%20portrait%20illustration%2C%20clean%20simple%20background%20with%20warm%20cream%20tones%2C%20beautiful%20Korean%20comic%20art%20style&width=420&height=600&seq=manga-cover-01&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '一段跨越阶级的爱情故事，女主角是财阀集团的继承人，男主角是普通职员。当爱情遭遇现实的考验，两人能否守住最初的承诺？这部漫画以其细腻的情感描写和精美的画风赢得了无数读者的喜爱，每一帧画面都充满了艺术感，故事情节扣人心弦，让人欲罢不能。',
    rating: 4.8,
    status: '连载中',
    updatedAt: '2026-08-04',
    views: 1582000,
    chapters: [
      { id: 'c1', number: 1, title: '命运的相遇', updatedAt: '2026-01-10' },
      { id: 'c2', number: 2, title: '擦肩而过的缘分', updatedAt: '2026-01-17' },
      { id: 'c3', number: 3, title: '心跳加速的瞬间', updatedAt: '2026-01-24' },
      { id: 'c4', number: 4, title: '不可言说的秘密', updatedAt: '2026-02-01' },
      { id: 'c5', number: 5, title: '靠近一步的距离', updatedAt: '2026-02-08' },
      { id: 'c6', number: 6, title: '暴风雨前的宁静', updatedAt: '2026-02-15' },
      { id: 'c7', number: 7, title: '崩塌的信任', updatedAt: '2026-02-22' },
      { id: 'c8', number: 8, title: '再次选择你', updatedAt: '2026-03-01' },
      { id: 'c9', number: 9, title: '深情的告白', updatedAt: '2026-03-08' },
      { id: 'c10', number: 10, title: '永恒的约定', updatedAt: '2026-03-15' },
    ],
  },
  {
    id: '2',
    slug: 'dragon-king',
    title: '龙王传说',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20powerful%20dragon%20king%20with%20mystical%20aura%2C%20epic%20fantasy%20illustration%2C%20golden%20and%20crimson%20tones%2C%20Korean%20comic%20art%20style%2C%20clean%20simple%20background%2C%20warm%20atmospheric%20lighting&width=420&height=600&seq=manga-cover-02&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '在一个人与龙共存的世界中，少年意外觉醒了龙族血脉，从此踏上成为最强龙王的传奇之路。恢弘的世界观，精彩的战斗场面，以及深刻的友情与羁绊，共同构成了这部令人热血沸腾的奇幻巨作。',
    rating: 4.7,
    status: '连载中',
    updatedAt: '2026-08-03',
    views: 2340000,
    chapters: [
      { id: 'c1', number: 1, title: '觉醒之日', updatedAt: '2026-01-05' },
      { id: 'c2', number: 2, title: '龙之试炼', updatedAt: '2026-01-12' },
      { id: 'c3', number: 3, title: '宿命的对手', updatedAt: '2026-01-19' },
      { id: 'c4', number: 4, title: '火焰中的誓言', updatedAt: '2026-01-26' },
      { id: 'c5', number: 5, title: '王者降临', updatedAt: '2026-02-02' },
      { id: 'c6', number: 6, title: '远古遗迹', updatedAt: '2026-02-09' },
      { id: 'c7', number: 7, title: '暗影逼近', updatedAt: '2026-02-16' },
      { id: 'c8', number: 8, title: '最后的防线', updatedAt: '2026-02-23' },
    ],
  },
  {
    id: '3',
    slug: 'shadow-hunter',
    title: '暗影猎手',
    author: '李敏镐',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20shadow%20hunter%20with%20dual%20blades%20in%20dark%20alley%2C%20noir%20action%20illustration%2C%20mysterious%20vibe%2C%20Korean%20comic%20art%20style%2C%20simple%20dark%20warm%20background%2C%20dramatic%20lighting&width=420&height=600&seq=manga-cover-03&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '夜幕降临，暗影猎手便开始行动。主角是一名拥有特殊能力的猎人，专门猎杀隐藏在人类社会中的怪物。快节奏的战斗、帅气的动作设计和悬疑的剧情，让这部作品成为了动作漫画爱好者的必读之作。',
    rating: 4.6,
    status: '已完结',
    updatedAt: '2026-07-28',
    views: 1890000,
    chapters: [
      { id: 'c1', number: 1, title: '暗夜降临', updatedAt: '2025-06-01' },
      { id: 'c2', number: 2, title: '第一场狩猎', updatedAt: '2025-06-08' },
      { id: 'c3', number: 3, title: '追踪', updatedAt: '2025-06-15' },
      { id: 'c4', number: 4, title: '猎人与猎物', updatedAt: '2025-06-22' },
      { id: 'c5', number: 5, title: '真相浮现', updatedAt: '2025-06-29' },
      { id: 'c6', number: 6, title: '最后之战', updatedAt: '2025-07-06' },
    ],
  },
  {
    id: '4',
    slug: 'mystery-cafe',
    title: '迷之咖啡馆',
    author: '崔智友',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20cover%20art%2C%20cozy%20cafe%20with%20mysterious%20atmosphere%2C%20warm%20lighting%20and%20shadows%2C%20intriguing%20illustration%2C%20Korean%20comic%20art%20style%2C%20simple%20warm%20cream%20background%2C%20soft%20mysterious%20vibe&width=420&height=600&seq=manga-cover-04&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    description: '城市角落的一家神秘咖啡馆，每一位光顾的客人都会留下一段不为人知的故事。女主角作为咖啡馆的老板，在一杯杯咖啡的香气中，揭开了一个个令人震惊的秘密。',
    rating: 4.5,
    status: '连载中',
    updatedAt: '2026-08-02',
    views: 876000,
    chapters: [
      { id: 'c1', number: 1, title: '第一位客人', updatedAt: '2026-02-10' },
      { id: 'c2', number: 2, title: '没有名字的订单', updatedAt: '2026-02-17' },
      { id: 'c3', number: 3, title: '午夜来客', updatedAt: '2026-02-24' },
      { id: 'c4', number: 4, title: '照片中的秘密', updatedAt: '2026-03-03' },
      { id: 'c5', number: 5, title: '雨夜的线索', updatedAt: '2026-03-10' },
    ],
  },
  {
    id: '5',
    slug: 'daily-laugh',
    title: '爆笑日常',
    author: '郑秀晶',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%20art%2C%20funny%20slice%20of%20life%20illustration%2C%20colorful%20and%20lively%20characters%2C%20bright%20playful%20style%2C%20Korean%20comic%20art%2C%20simple%20warm%20background%2C%20cheerful%20and%20humorous%20vibe&width=420&height=600&seq=manga-cover-05&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '四个性格迥异的室友住在一起，每天都有意想不到的搞笑事件发生。轻松幽默的四格漫画风格，让人在捧腹大笑中感受到温暖与友情。无论你心情多糟糕，看完这部漫画，保证让你笑出声来！',
    rating: 4.4,
    status: '连载中',
    updatedAt: '2026-08-04',
    views: 2100000,
    chapters: [
      { id: 'c1', number: 1, title: '新室友驾到', updatedAt: '2026-03-01' },
      { id: 'c2', number: 2, title: '厨房大作战', updatedAt: '2026-03-08' },
      { id: 'c3', number: 3, title: '谁是清洁担当', updatedAt: '2026-03-15' },
      { id: 'c4', number: 4, title: '外卖风波', updatedAt: '2026-03-22' },
      { id: 'c5', number: 5, title: '周末赖床大赛', updatedAt: '2026-03-29' },
      { id: 'c6', number: 6, title: '网购灾难', updatedAt: '2026-04-05' },
      { id: 'c7', number: 7, title: '相亲乌龙', updatedAt: '2026-04-12' },
      { id: 'c8', number: 8, title: '宠物大乱斗', updatedAt: '2026-04-19' },
    ],
  },
  {
    id: '6',
    slug: 'life-reversal',
    title: '人生逆转',
    author: '张东健',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%20art%2C%20emotional%20life%20story%20illustration%2C%20contrast%20between%20success%20and%20struggle%2C%20warm%20dramatic%20lighting%2C%20Korean%20comic%20art%20style%2C%20simple%20warm%20cream%20background%2C%20deep%20emotional%20tone&width=420&height=600&seq=manga-cover-06&orientation=portrait',
    category: '剧情',
    categorySlug: 'drama',
    description: '一个平凡的中年男人，因为一次意外获得了重新选择人生的机会。如果回到二十年前，你会做出怎样的选择？这部漫画以其深刻的主题和真实的情感描写，触动了无数读者的内心。',
    rating: 4.9,
    status: '已完结',
    updatedAt: '2026-07-15',
    views: 3200000,
    chapters: [
      { id: 'c1', number: 1, title: '平凡的一天', updatedAt: '2025-08-01' },
      { id: 'c2', number: 2, title: '回到过去', updatedAt: '2025-08-08' },
      { id: 'c3', number: 3, title: '第一次选择', updatedAt: '2025-08-15' },
      { id: 'c4', number: 4, title: '蝴蝶效应', updatedAt: '2025-08-22' },
      { id: 'c5', number: 5, title: '错过的爱', updatedAt: '2025-08-29' },
      { id: 'c6', number: 6, title: '第二次机会', updatedAt: '2025-09-05' },
      { id: 'c7', number: 7, title: '无悔的选择', updatedAt: '2025-09-12' },
      { id: 'c8', number: 8, title: '最终的答案', updatedAt: '2025-09-19' },
    ],
  },
  {
    id: '7',
    slug: 'campus-secret',
    title: '校园秘语',
    author: '韩佳人',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20cover%20art%2C%20beautiful%20campus%20scene%20with%20cherry%20blossoms%2C%20young%20love%20illustration%2C%20fresh%20and%20youthful%20style%2C%20Korean%20comic%20art%2C%20simple%20warm%20background%2C%20gentle%20spring%20atmosphere&width=420&height=600&seq=manga-cover-07&orientation=portrait',
    category: '校园',
    categorySlug: 'school',
    description: '高中校园里，一个安静的女孩和校园里最受欢迎的男孩之间的秘密故事。青春期的悸动、友情的考验、学业的压力，交织成一幅动人的青春画卷。',
    rating: 4.3,
    status: '连载中',
    updatedAt: '2026-08-01',
    views: 1450000,
    chapters: [
      { id: 'c1', number: 1, title: '开学的第一天', updatedAt: '2026-04-01' },
      { id: 'c2', number: 2, title: '图书馆的偶遇', updatedAt: '2026-04-08' },
      { id: 'c3', number: 3, title: '天台上的约定', updatedAt: '2026-04-15' },
      { id: 'c4', number: 4, title: '文化节筹备', updatedAt: '2026-04-22' },
      { id: 'c5', number: 5, title: '心跳的校运会', updatedAt: '2026-04-29' },
      { id: 'c6', number: 6, title: '雨中的告白', updatedAt: '2026-05-06' },
    ],
  },
  {
    id: '8',
    slug: 'palace-flower',
    title: '宫中花',
    author: '宋慧乔',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20cover%20art%2C%20ancient%20Korean%20palace%20with%20elegant%20lady%20in%20hanbok%2C%20traditional%20aesthetic%20illustration%2C%20soft%20warm%20colors%2C%20Korean%20comic%20art%20style%2C%20simple%20cream%20background%2C%20classical%20elegance&width=420&height=600&seq=manga-cover-08&orientation=portrait',
    category: '古风',
    categorySlug: 'historical',
    description: '朝鲜时代的宫廷中，一位出身平凡的女子被选入宫中，在权力与阴谋的漩涡中，她以智慧与勇气守护着自己的信念与爱情。精美的韩服描绘、考究的历史细节，带来沉浸式的古风阅读体验。',
    rating: 4.7,
    status: '连载中',
    updatedAt: '2026-08-03',
    views: 980000,
    chapters: [
      { id: 'c1', number: 1, title: '入宫', updatedAt: '2026-03-10' },
      { id: 'c2', number: 2, title: '初见君王', updatedAt: '2026-03-17' },
      { id: 'c3', number: 3, title: '宫中的规矩', updatedAt: '2026-03-24' },
      { id: 'c4', number: 4, title: '暗流涌动', updatedAt: '2026-03-31' },
      { id: 'c5', number: 5, title: '花宴之夜', updatedAt: '2026-04-07' },
      { id: 'c6', number: 6, title: '忠诚与背叛', updatedAt: '2026-04-14' },
    ],
  },
  {
    id: '9',
    slug: 'star-lovers',
    title: '星际恋人',
    author: '金秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20romance%20cover%20art%2C%20starry%20night%20sky%20with%20two%20lovers%2C%20futuristic%20romantic%20illustration%2C%20dreamy%20cosmic%20atmosphere%2C%20Korean%20comic%20art%20style%2C%20simple%20warm%20background%2C%20ethereal%20beauty&width=420&height=600&seq=manga-cover-09&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '来自不同星球的两个年轻人，因一次星际事故而相遇。跨越光年的爱情，能否战胜宇宙的法则？科幻与浪漫的完美结合，带给你前所未有的阅读体验。',
    rating: 4.6,
    status: '连载中',
    updatedAt: '2026-07-30',
    views: 1230000,
    chapters: [
      { id: 'c1', number: 1, title: '陨落之星', updatedAt: '2026-05-01' },
      { id: 'c2', number: 2, title: '异星来客', updatedAt: '2026-05-08' },
      { id: 'c3', number: 3, title: '超越语言的交流', updatedAt: '2026-05-15' },
      { id: 'c4', number: 4, title: '星空的约定', updatedAt: '2026-05-22' },
      { id: 'c5', number: 5, title: '追兵的阴影', updatedAt: '2026-05-29' },
    ],
  },
  {
    id: '10',
    slug: 'magic-academy',
    title: '魔法学园',
    author: '全智贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20academy%20cover%20art%2C%20magical%20school%20with%20students%20casting%20spells%2C%20enchanting%20illustration%2C%20warm%20magical%20glow%2C%20Korean%20comic%20art%20style%2C%20simple%20cream%20background%2C%20whimsical%20atmosphere&width=420&height=600&seq=manga-cover-10&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '在一所隐藏在普通世界中的魔法学院里，新生们开始学习控制自己的魔力。友情、竞争、冒险，以及隐藏在学院深处的古老秘密，等待着他们去探索。',
    rating: 4.5,
    status: '已完结',
    updatedAt: '2026-06-20',
    views: 2670000,
    chapters: [
      { id: 'c1', number: 1, title: '入学通知', updatedAt: '2025-09-01' },
      { id: 'c2', number: 2, title: '分院仪式', updatedAt: '2025-09-08' },
      { id: 'c3', number: 3, title: '第一节魔法课', updatedAt: '2025-09-15' },
      { id: 'c4', number: 4, title: '禁林探险', updatedAt: '2025-09-22' },
      { id: 'c5', number: 5, title: '期末考试', updatedAt: '2025-09-29' },
      { id: 'c6', number: 6, title: '毕业典礼', updatedAt: '2025-10-06' },
    ],
  },
  {
    id: '11',
    slug: 'action-hero',
    title: '热血英雄传',
    author: '刘在石',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20hero%20action%20cover%20art%2C%20young%20hero%20with%20fist%20raised%2C%20dynamic%20action%20pose%2C%20energetic%20illustration%2C%20Korean%20comic%20art%20style%2C%20simple%20warm%20background%2C%20powerful%20and%20bold%20composition&width=420&height=600&seq=manga-cover-11&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '一个普通高中生因为一次意外获得了超能力，从此踏上了守护城市和平的英雄之路。拳拳到肉的战斗场面、热血的剧情发展，让你感受动作漫画的极致魅力。',
    rating: 4.4,
    status: '连载中',
    updatedAt: '2026-08-04',
    views: 1800000,
    chapters: [
      { id: 'c1', number: 1, title: '能力觉醒', updatedAt: '2026-04-10' },
      { id: 'c2', number: 2, title: '第一次出击', updatedAt: '2026-04-17' },
      { id: 'c3', number: 3, title: '宿敌登场', updatedAt: '2026-04-24' },
      { id: 'c4', number: 4, title: '极限之战', updatedAt: '2026-05-01' },
    ],
  },
  {
    id: '12',
    slug: 'detective-k',
    title: '名侦探K',
    author: '宋仲基',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20detective%20mystery%20cover%20art%2C%20genius%20detective%20with%20magnifying%20glass%2C%20noir%20illustration%2C%20suspenseful%20atmosphere%2C%20Korean%20comic%20art%20style%2C%20simple%20warm%20dark%20background%2C%20intellectual%20and%20mysterious%20vibe&width=420&height=600&seq=manga-cover-12&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    description: '天才侦探K凭借敏锐的观察力和推理能力，破解了一个又一个看似不可能的谜案。每一个案件背后都隐藏着人性的复杂与真实，让人在烧脑中感受推理的魅力。',
    rating: 4.8,
    status: '已完结',
    updatedAt: '2026-05-30',
    views: 3100000,
    chapters: [
      { id: 'c1', number: 1, title: '消失的富商', updatedAt: '2025-10-01' },
      { id: 'c2', number: 2, title: '美术馆之谜', updatedAt: '2025-10-08' },
      { id: 'c3', number: 3, title: '最后的晚餐', updatedAt: '2025-10-15' },
      { id: 'c4', number: 4, title: '真相大白', updatedAt: '2025-10-22' },
    ],
  },
];

export const faqList = [
  {
    question: '韩漫之家是免费的吗？',
    answer: '是的，韩漫之家完全免费！我们致力于为漫画爱好者提供高质量的韩国漫画阅读体验，所有漫画均可免费在线阅读，无需任何付费。我们通过广告收入来维持网站运营，让每一位读者都能轻松享受精彩的漫画世界。',
  },
  {
    question: '什么是下拉式阅读模式？',
    answer: '下拉式阅读是我们为读者精心设计的特色功能。与传统的翻页模式不同，下拉式阅读让您可以像浏览网页一样，通过向下滚动来连续阅读漫画内容。这种方式更加流畅自然，无需频繁点击翻页，让您完全沉浸在漫画的故事情节中，获得如丝般顺滑的阅读体验。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '我们与多位韩国漫画家保持紧密合作，确保热门连载漫画能够及时更新。一般来说，热门漫画每周更新1-2话，部分作品可能因作者安排有所调整。您可以在首页的「最新更新」区域查看最近更新的漫画，也可以通过收藏功能第一时间获取更新通知。',
  },
  {
    question: '支持在手机上阅读吗？',
    answer: '当然支持！韩漫之家采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用什么设备，都能获得优质的漫画阅读体验。特别是在手机上，下拉式阅读模式的优势更加明显，单手操作即可轻松浏览漫画内容。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过多种方式找到心仪的漫画：在首页浏览推荐和热门排行，使用分类页面按类型筛选漫画，或直接使用搜索功能查找特定作品。我们也根据您的阅读偏好，在首页为您推荐可能感兴趣的漫画作品。',
  },
];

export const reviews = [
  {
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20Korean%20girl%20avatar%20profile%20picture%2C%20warm%20smile%2C%20simple%20cream%20background%2C%20illustration%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    comment: '终于找到一个可以免费看韩漫的网站了！画质超清晰，下拉式阅读体验太棒了，完全停不下来！',
  },
  {
    name: '星辰大海',
    avatar: 'https://readdy.ai/api/search-image?query=handsome%20Korean%20boy%20avatar%20profile%20picture%2C%20gentle%20smile%2C%20simple%20cream%20background%2C%20illustration%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    comment: '漫画更新速度很快，分类也很清晰。特别喜欢下拉式阅读这个功能，比翻页舒服多了。',
  },
  {
    name: '漫画迷妹',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Korean%20woman%20avatar%20profile%20picture%2C%20bright%20smile%2C%20simple%20cream%20background%2C%20illustration%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 5,
    comment: '推荐了好几部好看的漫画给朋友，都说很不错。希望网站越来越完善，收更多好看的韩漫！',
  },
];